exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Block-a1f7b5a9{position:relative;-moz-user-select:-moz-none}.Block-a1f7b5a9:focus{outline:none}.Block-a1f7b5a9 *{-moz-user-select:-moz-none}.isSelected-401a36a4:after{content:'';position:absolute;display:block;top:-1px;right:-1px;bottom:-1px;left:-1px;border:2px solid #8fb9ec;pointer-events:none}\n", ""]);

// Exports
exports.locals = {
	"Block": "Block-a1f7b5a9",
	"isSelected": "isSelected-401a36a4"
};